import * as React from 'react';

function SvgModalCloseIcon(props) {
  return (
    <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M13 1L1 13M13 13L1 1" stroke="#fff" strokeWidth={2} />
    </svg>
  );
}

export default SvgModalCloseIcon;
